export { hasFile, dirExist, createDir, outputToPath, readObjectFromPath, populateVariableFromPath, readStringFromPath } from '@iotv/core-services'
